<template>
    <div class="toast-container" ref="toast">

        <div class="bg"></div>

        <div class="toast-content">
            <div class="middle-content" v-html="content"></div>
            <div class="footer-content">
                <div class="btn" v-for="(item,index) in btn" 
                :key="index" 
                v-html="item.value" 
                @click="clickEv(item)"
                :class=" item.class "
                ></div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'toast',

    data() {
        return {
        }
    },

    methods: {

        //点击
        clickEv(item){
            if( !item.event ) return

            for(let val of item.event){
                typeof val === 'string' && this[val] && this[val]()
                typeof val === 'function' && val.call(this)
            }
        },

        //关闭移除
        closeEv() {
            this.$refs["toast"] && document.body.removeChild(this.$refs["toast"])
        }
        
    },
    
}
</script>

<style lang="less" scoped>
.toast-container{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 90;
    .bg{
        position: absolute;
        background: rgba(0,0,0,.6);
        width: 100%;
        height: 100%;
        z-index: -1;
    }
    .toast-content{
        background: #fff;
        width: 6.5rem;  
        border-radius: .12rem;
        overflow: hidden;
        .middle-content{
            font-size: 0.28rem;
            padding: .8rem .3rem;
        }
        .footer-content{
            display: flex;
            height: 1rem;
            line-height: 1rem;
            box-shadow: 0px 0px 1px 1px #bbb;
            .btn{
                flex: 1;
                font-size: .32rem;
                text-align: center;
                cursor: pointer;

                &.active{
                    background: #813f44;
                    color: #fff;
                }
            }
        }
    }

    //展开明细样式
    /deep/ .details-container{
        user-select: none;
        .details-title{
            margin-bottom: .3rem;
            font-size: .32rem;
            span{
                font-size: .4rem;
                font-weight: bold;
            }
        }
        .details-list{
            max-height: 50vh;
            overflow-y: auto;
            font-size: 0;
            padding-right: .2rem;
            .group{
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: .28rem;
                margin: .2rem 0;
                .time{
                    font-size: .24rem;
                    color: #666;
                    margin-top: .1rem;
                }
                .red{
                    color: #813f44;
                }
            }
        }
    }

    // 协议展示样式
    /deep/ .protocol-container{
        max-height: 60vh;
        .title{
            text-align: center;
            font-size: 0.32rem;
            font-weight: bold;
            margin-bottom: .3rem;
            color: #333;
        }
        div.protocol-content{
            font-size: .24rem;
            color: #666;
            line-height: 1.75;
            max-height: 60vh;
            overflow-y: auto;
            padding-right: 1em;
            li{
                margin-bottom: .26rem;
                p{
                    font-weight: bold;
                }
                div{
                    padding-left: 1em;
                }
            }
        }
    }
}
</style>